export default __webpack_public_path__ + "static/media/thank-you-bg.47a37cfe.png";